// removed by extract-text-webpack-plugin
module.exports = {"button":"button__7lCAZ","disabled":"disabled__1EGEU","primary":"primary__iRrTX","secondary":"secondary__A0YxJ","tertiary":"tertiary__xBKfY"};


//////////////////
// WEBPACK FOOTER
// ./components/button/button.css
// module id = 7Wgl
// module chunks = 0